<ng-container *ngIf="showBadge$ | async">
  <ng-container *ngIf="subscriptionTier$ | async as tier">
    <div
      *ngIf="canNavigateToMyPlanPage$(tier) | async; else notClickable"
      class="subscription-level clickable-subscription-level"
      (click)="handleOnSubLevelClick(tier)"
    >
      {{ subscriptionLevel$ | async | translate }}
    </div>
    <ng-template #notClickable>
      <span class="subscription-level">
        {{ subscriptionLevel$ | async | translate }}
      </span>
    </ng-template>
  </ng-container>
</ng-container>
